import * as React from 'react'
import { InputAdornment, TextField, StandardTextFieldProps as InputProps, useTheme } from '@mui/material'

import IconButton from '@mui/material/IconButton'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { styled } from '@mui/material/styles'

// import IconButton from '../icon-button'

const StyledTextField = styled(TextField)`
    // Disabled input
    & .MuiOutlinedInput-root.Mui-disabled > .MuiOutlinedInput-notchedOutline {
        border-style: dashed;
    }

    // What is this for?
    & .MuiOutlinedInput-root {
        input[value='']::-webkit-datetime-edit {
            color: transparent;
        }
        input:focus::-webkit-datetime-edit {
            color: ${({ theme }) => theme.palette.text.primary};
        }
        input {
            color-scheme: dark;
        }
    }

    // Input hover
    &:hover {
        & .MuiOutlinedInput-notchedOutline {
            background-color: ${({ theme, color }) => (color ? theme.palette[color]?.light : undefined)};
            border-color: ${({ theme, color }) => (color ? theme.palette[color]?.main : undefined)} !important;
        }
    }

    // Input label
    label {
        color: ${({ theme, color }) => (color ? theme.palette[color].main : undefined)};
    }

    /* What is this for? TODO: remove
    &:focus {
        & .MuiOutlinedInput-notchedOutline {
            border-color: ${({ theme, color }) => (color ? theme.palette[color].contrastText : undefined)} !important;
        }
    } */
`

const Input = (props: InputProps) => {
    const { color = 'primary' } = props
    const { palette } = useTheme()
    const [showPassword, setShowPassword] = React.useState(false)

    const handleClickShowPassword = () => {
        setShowPassword((curr) => !curr)
    }

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
    }

    if (props.type === 'password') {
        return (
            <StyledTextField
                {...props}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                sx={{ color: palette.grey[500] }}
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end">
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
                color={color}
                type={showPassword ? 'text' : 'password'}
            />
        )
    }

    if (props.type === 'date') {
        return <StyledTextField color={color} {...props} />
    }

    return <StyledTextField color={color} {...props} />
}

export default Input
